import { useScroll } from 'framer-motion'
import { useEffect, useState } from 'react'

import { styled } from '@mui/material/styles'
import { AWS_CDN_DOMAIN } from 'src/config-global'
// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(10, 0),
  [theme.breakpoints.up('md')]: {
    height: '15vh',
    padding: 10,
    margin: 10,
    // Round the corners
    borderRadius: '20px',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    bottom: 0,
    right: 0,
    height: '10px',
    backgroundColor: '#fff',
  },
}))

const StyledBackgroundVideo = styled('video')(({ theme }) => ({
  position: 'absolute',
  top: 100, // change this value as needed
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1,
  objectFit: 'cover', // similar to backgroundSize: 'cover' for images
  opacity: 2, // Adjust the opacity as needed
  width: '100%',
  height: '100%',

  // Make video top fading in white gradient
  '&::before': {
    content: "''",
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '100%',
    background: 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)',
  },
}))

const StyledEllipseTop = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '100vw', // Set the width to the full viewport width
  height: '25vh', // Increase the height to make the white area larger
  top: 1110, // change this value as needed
  left: 0, // Position it at the left
  borderRadius: '90%',
  filter: 'blur(100px)',
  WebkitFilter: 'blur(100px)',
  background: `linear-gradient(180deg, ${'#fff'}, ${'#fff'})`, // Apply the gradient background
  boxShadow: '0px 5px 15px rgba(0,0,0,0.2)', // Add a shadow for better visibility of links
}))

// ----------------------------------------------------------------------

export default function HomeBridgeVideo() {
  const { scrollYProgress } = useScroll()

  const [hide, setHide] = useState(false)

  useEffect(
    () =>
      scrollYProgress.onChange((scrollHeight) => {
        if (scrollHeight > 0.8) {
          setHide(true)
        } else {
          setHide(false)
        }
      }),
    [scrollYProgress],
  )

  if (hide) {
    return null
  }

  return (
    <StyledRoot>
      <StyledBackgroundVideo autoPlay muted loop src={AWS_CDN_DOMAIN + '/frontend-files/videos/bridge-video.mp4'} />
      <StyledEllipseTop />
    </StyledRoot>
  )
}

// ----------------------------------------------------------------------
